import { create } from 'zustand';
import { PaymentStatusData } from '@/bridge/types';
import { GetPromotionsDataType } from '@/components/Ad/Promotions/PromotionDrawer.helpers.types';

interface PaymentStatusModalStore {
  isWebViewPaymentModalOpen: boolean;
  webViewPaymentModalData: PaymentStatusData | null;
  openWebViewPaymentModal: (paymentData: PaymentStatusData) => void;
  closeWebViewPaymentModal: () => void;
  isSuccessPaymentModalOpen: boolean;
  setIsSuccessPaymentModalOpen: (isOpen: boolean) => void;
  successPaymentModalData: GetPromotionsDataType | null;
  setSuccessPaymentModalData: (paymentData: GetPromotionsDataType) => void;
}

export const usePaymentStatusModalStore = create<PaymentStatusModalStore>(
  set => ({
    isWebViewPaymentModalOpen: false,
    webViewPaymentModalData: null,
    openWebViewPaymentModal: paymentData =>
      set({
        isWebViewPaymentModalOpen: true,
        webViewPaymentModalData: paymentData,
      }),
    closeWebViewPaymentModal: () => set({ isWebViewPaymentModalOpen: false }),
    isSuccessPaymentModalOpen: false,
    successPaymentModalData: null,
    setIsSuccessPaymentModalOpen: (isOpen: boolean) =>
      set({ isSuccessPaymentModalOpen: isOpen }),
    setSuccessPaymentModalData: (paymentData: GetPromotionsDataType) =>
      set({ successPaymentModalData: paymentData }),
  })
);
